// packages/kb-view/src/cn.ts
//
// The same class-merge helper the application's shadcn components use
// (`apps/web/src/lib/utils.ts`). It cannot be imported across the package
// boundary, and the merge SEMANTICS are load-bearing rather than cosmetic: a
// caller's `className` overrides a conflicting prose utility instead of
// stacking with it, which is what keeps the extracted renderer byte-identical
// to the one it replaced.

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
